import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chatbotIntegration/chatbotIntegrationPopup.module.scss";
import Required from "../../../utility/required";

interface ConfigurationSectionProps {
    title?: string;
    description?: string;
    children?: ReactNode;
    isSectionRequired?: boolean;
}

const ConfigurationSection = (props: ConfigurationSectionProps) => {

    const { title, description, children, isSectionRequired } = props;

    return (
        <Grid container className={styles.configurationSection} direction="column">
            
            {title && (
                <Grid item xs={12}>
                    <Typography className={styles.configurationSectionTitle}>
                        {title}
                        {isSectionRequired && <Required />}
                    </Typography>
                </Grid>
            )}

            {description && (
                <Grid item xs={12}>
                    <Typography className={styles.configurationSectionDescription}>
                        {description}
                    </Typography>
                </Grid>
            )}

            {children && (
                <Grid item xs={12} className={styles.configurationSectionContent}>
                    {children}
                </Grid>
            )}
        </Grid>
    );
};

export default ConfigurationSection;